// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__16ict","Success":"Button_Success__3vA4d","Danger":"Button_Danger__28XXp"};